/**
 * Builds the URL for the plans page.
 */
const buildPlansUrl = (userProduct?: string, query?: string) => {
  return `/plans${userProduct ? `/${userProduct}` : ''}${query || ''}`;
};

export { buildPlansUrl };
